module.exports = __webpack_public_path__ + "static/img/compro_help2.e6b9e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compro_help2.png
// module id = 5q8q
// module chunks = 1